export var NORMAL = 'normal';
